<template>
  <DBox
    :id="'cmp-contacts-contacts-accounting_details'"
    class="contact-info"
    :addButton="false"
  >
    <div v-if="accountingInfo.contact">
      <TextField2
        :id="'legal_form'"
        :value="accountingInfo.contact.legal_form"
        :placeholder="$t('legal_form')"
        :label="$t('legal_form')"
        @blur="onTextFieldValueChange"
      />
      <TextField2
        :id="'registration'"
        :value="accountingInfo.contact.registration"
        :placeholder="$t('registration')"
        :label="$t('registration')"
        @blur="onTextFieldValueChange"
      />
      <Dropdown2
        :label="$t('currency')"
        :placeholder="$t('currency')"
        :options="currenciesTV"
        :selected="
          currenciesTV.find(c => c.value == accountingInfo.contact.currency_id)
        "
        v-on:selectedChange="e => onDropdownChange('currency_id', e)"
      />
      <TextField2
        :id="'customer_no'"
        :placeholder="$t('customer_no')"
        :label="$t('customer_no')"
        :value="accountingInfo.contact.customer_no"
        @blur="onTextFieldValueChange"
      />

      <TextField2
        :id="'creditor_no'"
        :placeholder="$t('creditor_id')"
        :label="$t('creditor_id')"
        :value="accountingInfo.contact.creditor_no"
        @blur="onTextFieldValueChange"
      />
      <TextField2
        :id="'debitor_no'"
        :placeholder="$t('debitor_no')"
        :label="$t('debitor_no')"
        :value="accountingInfo.contact.debitor_no"
        @blur="onTextFieldValueChange"
      />
      <TextField2
        :id="'tax_no'"
        :placeholder="$t('tax_no')"
        :label="$t('tax_no')"
        :value="accountingInfo.contact.tax_no"
        @blur="onTextFieldValueChange"
      />

      <div style="display: flex;">
        <TextField2
          id="vat_no"
          :label="$t('vat_id')"
          :value="accountingInfo.contact.vat_no"
          :bb="'0px'"
          :cw="
            `clamp(48px, ${(
              (accountingInfo.contact && accountingInfo.contact.vat_no) ||
              ''
            ).toString().length * 13}px, 140px)`
          "
          @blur="onTextFieldValueChange"
          :style="{
            '--fc2-tf-margin-focus': '-1px 3px -1px 0px'
          }"
        />
        <div class="fcc" style>
          <div class="loading-icon" v-if="vatIdValidityLoading">
            <img src="static/icons/loading.gif" alt />
          </div>
          <div
            v-if="!vatIdValidityLoading"
            :class="`status-button ${this.vatIdValidity ? 'valid' : 'invalid'}`"
            @click="onVatValButtonClick"
          >
            {{ this.vatIdValidity ? $t('valid') : $t('invalid')}}
          </div>
        </div>
      </div>

      <!-- <v-layout row wrap>
        <v-flex md6>
          <Dropdown
            class="dt-dropdown"
            :options="currenciesTV"
            :selected="
              currenciesTV.find(
                (c) =>
                  c.value == accountingInfo.contact.currency_id
              )
            "
            box
            :placeholder="$t('currency')"
            v-on:selectedChange="
              (e) => onDropdownChange('currency', e)
            "
            :listHeight="150"
          ></Dropdown>
        </v-flex>
        <v-flex md6>
          <TextField
            :id="'customer_no'"
            v-bind="textFieldConfig"
            :value="accountingInfo.contact.customer_no"
            :placeholder="$t('customer_no')"
            @valuechanged="onTextFieldValueChange"
          />
        </v-flex>
      </v-layout>
      <v-layout row wrap>
        <v-flex md6>
          <TextField
            :id="'creditor_no'"
            v-bind="textFieldConfig"
            :value="accountingInfo.contact.creditor_no"
            :placeholder="$t('creditor_no')"
            @valuechanged="onTextFieldValueChange"
          />
        </v-flex>
        <v-flex md6>
          <TextField
            :id="'debitor_no'"
            v-bind="textFieldConfig"
            :value="accountingInfo.contact.debitor_no"
            :placeholder="$t('debitor_no')"
            @valuechanged="onTextFieldValueChange"
          />
        </v-flex>
      </v-layout> -->
    </div>
  </DBox>
</template>

<script>
import DBox from "@dtplugins/dbox/dbox";
import { createCurrencyTV } from "../../../../models/currency.model";
import { checkVATNumber } from "../../models/vat.model";

export default {
  components: {
    DBox
  },
  props: {
    accountingInfo: {
      type: Object,
      required: true
    },

    vatIdValidity: { type: Boolean },
    vatIdValidityLoading: { type: Boolean }
  },
  data: function() {
    return {};
  },
  computed: {
    currenciesTV: function() {
      return createCurrencyTV(this.accountingInfo.currencies);
    }
  },
  methods: {
    onTextFieldValueChange: function({ name, value }) {
      this.$emit("changed", { name, value });
    },
    onDropdownChange: function(name, value) {
      this.$emit("changed", { name, value: value.value });
    },
    onVatIDUpdate: function({ name, value }) {
      this.$emit("vat_update", {
        name,
        value
      });
    },
    onVatValButtonClick: function() {
      checkVATNumber(this.accountingInfo.contact.vat_no || "");
    }
  }
};
</script>

<style lang="scss" scoped>
.form-group {
  .dt-dropdown {
    margin: 5px 5px !important;
  }
  .status-button {
    padding-top: 3px;
    padding-bottom: 4px;
  }
}
</style>
